// src/utils/httpError.ts
var HttpError = class _HttpError extends Error {
  code;
  isHttpError = true;
  request;
  response;
  status;
  statusText;
  cause;
  constructor(message, init = {}) {
    super(message);
    this.name = "HttpError";
    this.code = init.code;
    this.request = init.request;
    this.response = init.response;
    this.status = init.response?.status;
    this.statusText = init.response?.statusText;
    this.cause = init.cause;
  }
  static fromResponse(response, init = {}) {
    return new _HttpError(init.message ?? `Request failed with status code ${response.status}`, {
      code: init.code ?? getHttpErrorCode(response.status),
      request: init.request,
      response: {
        data: init.data,
        headers: response.headers,
        status: response.status,
        statusText: response.statusText,
        url: response.url
      }
    });
  }
};
var getHttpErrorCode = (status) => {
  return status >= 500 ? "ERR_BAD_RESPONSE" : "ERR_BAD_REQUEST";
};
var isHttpError = (error) => {
  return error instanceof HttpError || error instanceof Error && "isHttpError" in error && error.isHttpError === true;
};

// src/utils/panic.ts
var panic = (message) => {
  console.error(message);
  throw new Error(message);
};
var safePanic = ({ message, fallback, onError }) => {
  console.error(message);
  onError?.(new Error(message));
  return fallback;
};

export {
  HttpError,
  isHttpError,
  panic,
  safePanic
};
